import { Record } from 'immutable'

const ContentDataRecord = Record({
  text: undefined,
})

export default ContentDataRecord
